module.exports = __webpack_public_path__ + "img/autoshow-slide-04.05625b73.png";